/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WeatherInputResponse } from '../../models/weather-input-response';

export interface GetWeatherInputData$Params {
  location_id: string;
  from?: string;
  to?: string;
  source?: string;
}

export function getWeatherInputData(http: HttpClient, rootUrl: string, params: GetWeatherInputData$Params, context?: HttpContext): Observable<StrictHttpResponse<WeatherInputResponse>> {
  const rb = new RequestBuilder(rootUrl, getWeatherInputData.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('source', params.source, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WeatherInputResponse>;
    })
  );
}

getWeatherInputData.PATH = '/locations/{location_id}/forecast-input/weather';
